import type {
  InternalDropdownOption,
  InternalDropdownOptions,
} from '~/chords/DropdownSingleSelect/types';

/**
 * Update isVisible=true for all options.
 * Supports both flat and grouped (nested) option arrays.
 * @param options - The options to update (flat or grouped).
 * @returns The updated options with isVisible set to true.
 */
export function updateIsVisibleTrue(
  options: InternalDropdownOptions,
): InternalDropdownOptions {
  return options.map((group) =>
    group.map(
      (option): InternalDropdownOption => ({
        ...option,
        isVisible: true,
      }),
    ),
  );
}
